const filterReducer = (state, action) => { 
  switch (action.type) {
     case "load_filter_product":
       return { 
        ...state,
         filter_products: [...action.payload], 
         all_products: [...action.payload], };
         
         case "set_grid": 
         return { 
          ...state, 
          grid_view: true 
        };  
         
         case "set_list":
           return { 
            ...state,
             grid_view: false
           }; 
           
          case "get_sort":
             
             return {
               ...state,
                sorting_value: action.payload,
               }; 
               
           case "sorting_products": {
  const { filter_products, sorting_value } = state;
  let tempSortProduct = [...filter_products];

  const sortingProducts = (a, b) => {
    if (sorting_value === "a-z") {
      return (a.SKU || "").localeCompare(b.SKU || "");
    } else if (sorting_value === "z-a") {
      return (b.SKU || "").localeCompare(a.SKU || "");
    } else if (sorting_value === "lowest") {
      return a.price - b.price;
    } else if (sorting_value === "highest") {
      return b.price - a.price;
    }
    return 0; // default no change
  };

  const newSortData = tempSortProduct.sort(sortingProducts);
               
return{ ...state,
    filter_products: newSortData, 
  }; 
}
case "update_filter":
   const {name,value}=action.payload;
    return{
       ...state, 
       filters:{
         ...state.filters, 
         [name]:value } 
        } 
    
   
  case "Set_Subcategories":
    return {
      ...state,
      subcategories: action.payload   // backend array of subcategories
    };

case "Set_Items":
  return {
    ...state,
    items: action.payload           // backend array of items
  };

case "Set_Filtered_Products":
  return {
    ...state,
    filter_products: action.payload // backend-filtered products
  };
   

  case "clear_filters":
     return { 
      ...state,
       filters: { 
        ...state.filters,
         text: "", 
         category: "All",
          subcategory: "All",
           Item: "All"
       } 
      }; 
default: return state } } 
                  
                  
      export default filterReducer